import { EnumAppSource } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

export const getAppSourceDisplayValue = (
  value: number | undefined,
  translateFunc: (key: string) => string
) => {
  if (value === undefined || !EnumAppSource[value]) return '';

  return translateFunc(`EnumAppSource.${EnumAppSource[value]}`);
};
